module.exports = __webpack_public_path__ + "assets/img/n6.f4b2a17e.png";